// Pure formatting helpers shared by every layer. Minutes everywhere (contract).

// 125 → "2 h 5 m", 60 → "1 h", 0/null → "—"
export function hm(min) {
  const m0 = Math.round(min || 0);
  if (!m0) return "—";
  const h = Math.floor(m0 / 60);
  const m = m0 % 60;
  return [h ? `${h} h` : "", m ? `${m} m` : ""].filter(Boolean).join(" ") || "0 m";
}

// "2h 30m" / "90" / "1.5h" → minutes (null when unparseable)
export function parseEst(v) {
  if (v == null) return null;
  const s = String(v).trim().toLowerCase();
  if (!s) return null;
  let min = 0;
  const h = s.match(/(\d+(?:\.\d+)?)\s*h/);
  const m = s.match(/(\d+)\s*m/);
  if (h) min += Math.round(+h[1] * 60);
  if (m) min += +m[1];
  if (!h && !m && /^\d+$/.test(s)) min = +s;
  return min || null;
}

export function pct(a, b) {
  return b ? Math.round((a / b) * 100) : 0;
}

export function initialsOf(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return parts.length === 1 ? parts[0].slice(0, 2).toUpperCase() : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export const CATS = { todo: "To do", in_progress: "In progress", blocked: "Blocked", done: "Done", cancelled: "Cancelled" };
export const PRIORITIES = ["low", "medium", "high", "urgent"];

export function cap(s = "") {
  return s ? s[0].toUpperCase() + s.slice(1) : s;
}

export function isDoneCat(cat) {
  return cat === "done" || cat === "cancelled";
}
export function isDone(task) {
  return !!task && (isDoneCat(task.statusCategory) || !!task.completedAt);
}
export function categoryOf(task) {
  if (!task) return "todo";
  if (task.statusCategory === "cancelled") return "cancelled";
  if (isDone(task)) return "done";
  return task.statusCategory || "todo";
}

// Only the ai tier present → the number is an estimate, prefix "≈".
export function approxPrefix(actual) {
  if (!actual) return "";
  return actual.ai && !actual.explicit && !actual.match ? "≈ " : "";
}

export function timeAgo(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const m = Math.round(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(h / 24);
  return `${d} d ago`;
}
